/**
 * Cycles admin tab.
 *
 * Extracted from AdminApp.jsx (Feb 2026 modularisation pass). Renders the
 * cycles list, "New cycle" form, and delegates all data fetching to the
 * shared `/admin/cycles` API. Zero behavioural change from the previous
 * inline version.
 */
import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import api from "../../api";
import { PageHeader } from "./_shared";

export default function CyclesTab({ isClient = false }) {
  const [cycles, setCycles] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [showForm, setShowForm] = useState(false);

  const load = () => api.get("/admin/cycles").then((r) => setCycles(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/admin/cycles", { name, description: desc });
    setName(""); setDesc(""); setShowForm(false);
    load();
  };

  return (
    <div className="space-y-8 fade-in">
      <PageHeader eyebrow="ASSESSMENT CYCLES" title="Cycles" subtitle="Each cycle scopes a population & a time window for assessment delivery." />
      {!isClient && (
        <div className="flex justify-end">
          <button onClick={() => setShowForm(!showForm)} className="btn btn-primary" data-testid="new-cycle-btn">
            <Plus size={16} /> New cycle
          </button>
        </div>
      )}
      {showForm && !isClient && (
        <form onSubmit={create} className="card p-6 space-y-4 fade-in">
          <input className="input" placeholder="Cycle name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="cycle-name-input" />
          <textarea className="input" placeholder="Description" value={desc} onChange={(e) => setDesc(e.target.value)} rows={3} />
          <button className="btn btn-primary" type="submit" data-testid="create-cycle-submit">Create</button>
        </form>
      )}
      <div className="card overflow-hidden">
        <table className="data-table">
          <thead>
            <tr><th>Name</th><th>Description</th><th>Window</th><th>Status</th></tr>
          </thead>
          <tbody>
            {cycles.map((c) => (
              <tr key={c.id}>
                <td className="font-semibold">{c.name}</td>
                <td className="text-[#525252]">{c.description || "—"}</td>
                <td className="text-[#525252]">{c.start_date || "—"} → {c.end_date || "—"}</td>
                <td><span className={`badge ${c.status === "active" ? "badge-success" : "badge-neutral"}`}>{c.status}</span></td>
              </tr>
            ))}
            {cycles.length === 0 && <tr><td colSpan={4} className="text-center text-[#878787] py-12">No cycles yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
